import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, FormGroupDirective, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RouterLink } from '@angular/router';
import { environment } from '@uw-env/environment';
import { Roles } from '@uw/core/enums/role.enum';
import { UnitedWay } from '@uw/core/models/unitedway.model';
import { AuthService } from '@uw/core/services/auth.service';
import { MenuService } from '@uw/themes/services/menu.service';
import { BehaviorSubject, switchMap, tap } from 'rxjs';
import { SwitchUwModalComponent } from '../../modals/switch-uw-modal/switch-uw-modal.component';
import { customEmailValidator } from '@uw/shared/validators/custom-email-validator';
import { MatInput, MatError } from '@angular/material/input';
import { UwButtonComponent } from '../../../../shared/components/button/button.component';
import { MatButton } from '@angular/material/button';
import { LanguageSelectorComponent } from '../../../../shared/components/language-selector/language-selector.component';
import { TranslateModule } from '@ngx-translate/core';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    imports: [ReactiveFormsModule, MatInput, MatError, UwButtonComponent, MatButton, RouterLink, LanguageSelectorComponent, TranslateModule]
})
export class LoginFormComponent implements OnInit {

  loginFormGrp!: UntypedFormGroup;
  matcher = new MyErrorStateMatcher();
  errorMessage!: string;
  buttonLoading = false;

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    private router: Router,
    private menuService: MenuService,
    private readonly _dialog: MatDialog
    ) {

    this.menuService.showDonarSubMenu(true);
    this.createForm();
  }

  ngOnInit(): void {

  }

  createForm(){
    if (environment.mode !== 'dev') {
      this.loginFormGrp = this.fb.group({
        username: [null,[Validators.required, customEmailValidator()]],
        password: [null,[Validators.required]]
      });
    } else {
      this.loginFormGrp = this.fb.group({
        username: ['anis@protiviti.com',[Validators.required, customEmailValidator()]],
        password: ['Protiviti1!',[Validators.required]]
      });
    }
  }

  onNoClick(): void {
    //this.dialogRef.close();
  }

  login(): void {
    this.errorMessage = '';
    this.buttonLoading = true;
    this.authService.authenticateUser(this.loginFormGrp.value).subscribe(data=> {
      if (data && data.roleCode !== Roles.SystemAdministrator ){
        this.buttonLoading = true;
        this.router.navigate(['/private']);
      } else {
        this.openUnitedWaySwitcherModal().subscribe();
      }
    }, err=>{
      this.buttonLoading = false;
      this.errorMessage = err && err.message  ? err.message : 'Login Failed!';
    });
  }


  openUnitedWaySwitcherModal(){
    return this._dialog.open(SwitchUwModalComponent, {
          panelClass: 'uw-dialog-panel',
          disableClose: true
        })
          .afterClosed()
          .pipe(
            switchMap((unitedWay: UnitedWay) => this.authService.switchContext(unitedWay.unitedWayId)
            .pipe(tap(_ =>   this.router.navigate(['/private']))))
          );
  }

  showPassword(passwordControl: any) {
    if (passwordControl.type === "password") {
      passwordControl.type = "text";
    } else {
      passwordControl.type = "password";
    }
  }

}
